import React, { Component } from 'react'
import PropTypes from 'prop-types'

class RoundsCount extends Component {
  constructor(props){
    super(props)
  }

  render() {
    const { count, description } = this.props.content

    return (
      <div className='widget-content-statistics widget-content-statistics-darker'>
          <div className='count'>{ count }</div>
          <div className='description'>{ description }</div>
      </div>
    )
  }
}

RoundsCount.propTypes = {
  content: PropTypes.object,
}


RoundsCount.defaultProps = {
  content: {
    count: 0,
    description: !window.I18n ? '' : window.I18n.t('dashboard_menu.components.content.rounds_count.description'),
  },
}

export default RoundsCount
